import React, { Component } from 'react';
import moment from 'moment';
import I18n from '~/utils/translations';

export default class AvailableDate extends Component {
  formattedDateString() {
    const { availableDate } = this.props;

    const today = moment();
    if (availableDate) {
      const availableDateMoment = moment(availableDate);
      const formatString = availableDateMoment.isSame(today, 'year') ? 'D MMMM' : 'D MMMM YYYY';
      return I18n.t('pages.homes.home_status.available_from', {
        date_available: availableDateMoment.format(formatString),
      });
    } else {
      return I18n.t('pages.homes.home_status.unavailable');
    }
  }

  render() {
    const availabilityStatus = this.props.availableDate ? 'available' : 'unavailable';

    return (
      <div className={`home-tile__status--${availabilityStatus}`}>
        <div className={`home-tile__availability-status-text-container`}>
          <div className={`home-tile__text--${availabilityStatus}`}>{this.formattedDateString()}</div>
        </div>
      </div>
    );
  }
}
